import "../scss/index.scss";

document.addEventListener(
    "DOMContentLoaded",
    function () {
        addCloseButton();
        animateLinearLine();
        animateAffiliateSlider();
        animateCtaFooter();
        animateServices();
        animationTriggers();
        smoothScrollAccordionsNav();
        toggleAccodionClass();
        backToTop();
    }
);

function animationTriggers() {

    window.addEventListener('scroll', function () {
        // animate the linear line under page title
        animateLinearLine();
        animateAffiliateSlider();
        animateCtaFooter();
        animateServices();
    });

    window.addEventListener('resize', function () {
        // animate the linear line under page title
        animateLinearLine();
        animateAffiliateSlider();
        animateCtaFooter();
        animateServices();
    });
}

// Add close button to menu for mobile
function addCloseButton() {
    const nav = document.querySelector('#navbar');
    if(!nav) return;
    // create button
    const button = document.createElement('button');
    button.classList.add('navbar-toggle');
    button.classList.add('close-nav');
    button.setAttribute('data-toggle', 'collapse');
    button.setAttribute('data-target', '#navbar');
    button.setAttribute('aria-controls', 'navbar');
    button.setAttribute('type', 'button');
    button.setAttribute('aria-label', 'Close');
    // create span
    const span = document.createElement('span');
    span.setAttribute('aria-hidden', 'true');
    span.innerHTML = '&times;';
    // append span to button
    button.appendChild(span);
    // append button to nav
    nav.appendChild(button);
    // on button click
    button.addEventListener('click', function () {
        // remove open class from nav
        nav.classList.remove('open');
    });
}
function backToTop() {
    const backToTop = document.querySelector(".back-to-top");
    if(!backToTop) return;

    const anchor = backToTop.querySelector("a");
    if(!anchor) return;

    // on anchor click
    anchor.addEventListener('click', (e) => {
        e.preventDefault();
        scrollTo(document.getElementsByTagName("BODY")[0]);
    });
}

// animate the linear line under page title
function animateLinearLine() {
    elementFromTop(document.querySelectorAll('.animate-on-scroll'), 'linear-line', 'animate', 90, 'percent');
}

// animate the affiliate slider
function animateAffiliateSlider() {
    elementFromTop(document.querySelectorAll('.affiliations'), 'flexslider', 'animate', 90, 'percent');
}

// animate the cta footer
function animateCtaFooter() {
    elementFromTop(document.querySelectorAll('.cta'), 'cta__content', 'animate', 90, 'percent');
}

// animate services
function animateServices() {
    elementFromTop(document.querySelectorAll('#services .container'), 'service', 'animate', 90, 'percent');
}

// smooth scroll accordions nav
function smoothScrollAccordionsNav() {
    const navs = document.querySelectorAll('.accordions-nav .nav-link');
    if(!navs) return;
    for (let i = 0; i < navs.length; i++) {
        navs[i].addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(e.target.getAttribute('href'));
            scrollTo(target);
        });
    }
}

// toggle class on accordions
function toggleAccodionClass() {
    const toggleBtn = document.querySelectorAll('.accordion-toggle');
    if(!toggleBtn) return;
    for(let i = 0; i < toggleBtn.length; i++) {
        toggleBtn[i].addEventListener('click', function () {
            // remove open class from all accordions
            for(let j = 0; j < toggleBtn.length; j++) {
                toggleBtn[j].classList.remove('active');
            }
            // get aria expanded value
            const ariaExpanded = this.getAttribute('aria-expanded');
            // if aria expanded is false
            if(ariaExpanded === 'false') {
                // remove active class to this
                this.classList.remove('active');
            } else {
                // add active class from this
                this.classList.add('active');
            }
        });
    }
}

function scrollTo(element) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: element.offsetTop
    });
  }

/*
*
* http://fofwebdesign.co.uk/template/_testing/scroll-in-view/add-class-to-target-when-trigger-in-view-reduced.htm
*
*/
function hasClass(el, cls) {
    if (el.className.match('(?:^|\\s)' + cls + '(?!\\S)')) { return true; }
}
function addClass(el, cls) {
    if (!el.className.match('(?:^|\\s)' + cls + '(?!\\S)')) { el.className += ' ' + cls; }
}
function delClass(el, cls) {
    el.className = el.className.replace(new RegExp('(?:^|\\s)' + cls + '(?!\\S)'), '');
}

// params:  trigger element, target element class, classes to add to target element, trigger element distance from top, unit ('percent' or 'pixels')
// usage:   elementFromTop(elemTrigger, elemTarget, classToAdd, distanceFromTop, unit);
function elementFromTop(elemTrigger, elemTarget, classToAdd, distanceFromTop, unit) {
    var winY = window.innerHeight || document.documentElement.clientHeight,
        elTriggerLength = elemTrigger.length,
        elTargetLength, distTop, distPercent, distPixels, distUnit, elTarget, i, j;
    for (i = 0; i < elTriggerLength; ++i) {
        elTarget = document.querySelectorAll('.' + elemTarget);
        elTargetLength = elTarget.length;
        distTop = elemTrigger[i].getBoundingClientRect().top;
        distPercent = Math.round((distTop / winY) * 100);
        distPixels = Math.round(distTop);
        distUnit = unit == 'percent' ? distPercent : distPixels;
        if (distUnit <= distanceFromTop) {
            if (!hasClass(elemTrigger[i], elemTarget)) {
                for (j = 0; j < elTargetLength; ++j) {
                    if (!hasClass(elTarget[j], classToAdd)) { addClass(elTarget[j], classToAdd); }
                }
            } else {
                if (!hasClass(elemTrigger[i], classToAdd)) { addClass(elemTrigger[i], classToAdd); }
            }
        } else {
            delClass(elemTrigger[i], classToAdd);
            if (!hasClass(elemTrigger[i], elemTarget)) {
                for (j = 0; j < elTargetLength; ++j) { delClass(elTarget[j], classToAdd); }
            }
        }
    }
}